import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../../store";
import * as CustomerBillsStore from "../../store/CustomerBillsReducer";
import * as CustomerBillsAction from "../../store/CustomerBills";
import * as AuthorizationStore from "../../store/AuthorizationReducer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  faCarCrash,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Container, Nav, NavItem, NavLink, Spinner, TabContent, TabPane } from "reactstrap";

import { AnyAction, bindActionCreators } from "redux";
import { ThunkDispatch } from "redux-thunk/es/types";
import LoadingModal from "../LoadingModal";
import classNames from "classnames";
import ErrorMessage from "../modals/ErrorMessage";
import BillingSearchGrid from "./BillingSearchGrid";
import { UserProfileDetails } from "../UserProfile";

import * as QueryString from "query-string";
import { qvals } from "../../store/Interfaces";


const angleDown = <FontAwesomeIcon icon={faAngleDown} />;
const angleRight = <FontAwesomeIcon icon={faAngleRight} />;
const fileAlt = <FontAwesomeIcon className="ml-2" icon={faFileAlt} />;
const networkError = (
  <FontAwesomeIcon icon={faCarCrash} color="red" size="4x" />
);
const networkSuccess = <Spinner animation="border" size="sm" />;

// At runtime, Redux will merge together...
type CustomerBillsProps = CustomerBillsStore.CustomerBillsState & // ... state we've requested from the Redux store
  AuthorizationStore.State & // ... state we've requested from the Redux store
  temp &
  RouteComponentProps<{}> & // ... plus incoming routing parameters
  MyComponentOwnProps;

interface temp {
  actions: {
    customerbillsActions: AnyAction;
  };
}
// const toggleCaptchaBadge = (show: boolean) => {
//   const badge = document.getElementsByClassName('grecaptcha-badge')[0];
//   if (badge && badge instanceof HTMLElement) {
//     badge.style.visibility = show ? 'visible' : 'hidden';
//   }
// };
let interval = setInterval(() => { }, 10000);
class CustomerBills extends React.PureComponent<CustomerBillsProps> {
  public componentWillUnmount() {
    clearInterval(interval);
  }

  // This method is called when the component is first added to the document
  public componentDidMount() {


    this.ensureDataFetched();

    clearInterval(interval);
    // interval = setInterval(() => {
    //   this.ensureDataFetched();
    // }, 10000);
  }

  // This method is called when the route parameters change
  public componentDidUpdate() {
    // this.ensureDataFetched();
  }

  private handleRowClick(rowId: number) {
    // console.log('handleRowClick')

  }

  private formatTime(seconds: number) {
    return (
      (seconds > 3600 ? Math.floor(seconds / 3600).toString() + ":" : "") +
      Math.floor((seconds % 3600) / 60).toString() +
      ":" +
      this.pad(seconds % 60).toString()
    );
  }

  private pad(d: number) {
    return d < 10 ? "0" + d.toString() : d.toString();
  }

  public render() {
    localStorage.removeItem("agentAccess");
    let querystring = QueryString.parse(this.props.location.search);
    let target: qvals = new qvals();
    let query = Object.assign(target, querystring);
    if (query.w) {

      localStorage.setItem("accessToken", query.w);
      localStorage.setItem("agentAccess", "true");
    }
    // toggleCaptchaBadge(false);
    if (localStorage.getItem("accessToken")) {
      return (
        <Container>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classNames({ active: this.props.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  CABS Invoices
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classNames({ active: this.props.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Manage Profile
                </NavLink>
              </NavItem>

              <NavItem className="ml-5">
                <a href={process.env.REACT_APP_API_HOST + "/cabsbill/userguide"} className="btn btn-outline-primary" target="_blank">{fileAlt} User Guide</a>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.props.activeTab}>
              <TabPane tabId="1">
                {this.props.bans.length > 0 && <BillingSearchGrid bans={this.props.bans} btnDropright={this.props.btnDropright} actions={this.props.actions}></BillingSearchGrid>}
                {this.props.isError && (
                  <ErrorMessage key="errorMessage1"></ErrorMessage>
                )}


              </TabPane>
              <TabPane tabId="2">
                <UserProfileDetails ></UserProfileDetails>
              </TabPane>
            </TabContent>
          </div>

          <LoadingModal isLoading={this.props.isLoading}
          ></LoadingModal>
        </Container>

      );
    } else {
      return <></>
    }
  }

  toggle(tab: string) {
    this.props.actions.customerbillsActions.requestsetActiveTab(tab,
      () => {
        this.forceUpdate();
      }
    );
  }

  private ensureDataFetched() {
    // const expandedRows = this.props.expandedRows;
    this.props.actions.customerbillsActions.requestuserbans(
      () => {
        this.forceUpdate();
      }
    );


  }

}

interface MyComponentOwnProps {
  // startDateIndex: string | undefined;
  // customerbillsname: string | null;
  // subgroupname: string | null;
  // parent: string;
}
const mapStateToProps = function (
  state: ApplicationState,
  ownProps: MyComponentOwnProps
) {
  //  console.log('ownprops' + ownProps.subgroup);
  // console.log('state' + state.subgroupcompany.subgroupcompany);
  return {
    btnDropright: state.customerbillsstate ? state.customerbillsstate.btnDropright : [],
    activeTab: state.customerbillsstate ? state.customerbillsstate.activeTab : [],
    isLoading: state.customerbillsstate ? state.customerbillsstate.isLoading : false,
    bans: state.customerbillsstate ? state.customerbillsstate.bans : undefined,
  };
};

function mapDispatchToProps(
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: MyComponentOwnProps
) {
  return {
    actions: {
      customerbillsActions: bindActionCreators(CustomerBillsAction.actionCreators, dispatch),

    },
  };
}

export default connect(
  mapStateToProps, // Selects which state properties are merged into the component's props
  mapDispatchToProps // Selects which action creators are merged into the component's props
)(CustomerBills as any);
